module.exports = __webpack_public_path__ + "img/mstile-70x70.b171221d.png";